import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';


document.addEventListener("DOMContentLoaded", function () {
gsap.registerPlugin(ScrollTrigger);
const LawPanels = document.querySelectorAll('.AllForLaw .LawPanel');

const scrollEndValue = -LawPanels.length * 1500;
const t2 = gsap.timeline({
    scrollTrigger: {
        trigger: '.AllForLaw',
        scrub: 3,
        snap: 0,
        start: 'top +77',
        end: `bottom ${scrollEndValue}`,
        pin: true,
        markers: false,
    },
});


LawPanels.forEach((panel, index) => {
    const currentPanel = index + 1;
    const nextPanelId = `LawPanel${currentPanel + 1}`;
    const newtextContent = $(`.${nextPanelId} .content`).html();
    const newImagesContent = $(`.${nextPanelId} .images_wrapper`).html();

    if (currentPanel == 1) {
        t2
        // .from(".LawPanel .content", { duration: 4, opacity: 0, y: 400, ease: "power1.out" })
        // .from('.LawPanel .images_wrapper', { duration: 4, y: -400, opacity: 0, ease: 'power1.out' })

        .add([
            gsap.fromTo(".LawPanel .content",{opacity: 0, y: 400}, { duration: 4, opacity: 1, y: 0, ease: "power1.out" }),
            gsap.fromTo('.LawPanel .images_wrapper',{y: -400, opacity: 0}, { duration: 4, y: 0, opacity: 1, ease: 'power1.out' })
        ])
    }
    if (newtextContent && newImagesContent) {
        t2
        .add([
            // gsap.from(".LawPanel .content", { duration: 4, opacity: 1, y: 0, ease: "power1.out" }),
            gsap.fromTo('.LawPanel .content',{opacity: 1, y: 0}, { duration: 4, opacity: 0, y: -400, ease: 'power1.out' }),
            // gsap.from('.LawPanel .images_wrapper', { duration: 4, y: 0, opacity: 1, ease: 'power1.out' }),
            gsap.fromTo('.LawPanel .images_wrapper',{ y: 0, opacity: 1} ,{ duration: 4, y: -400, opacity: 0, ease: 'power1.out' }),
        ])

        .set('.LawPanel .content', { innerHTML: newtextContent })
        .set('.LawPanel .images_wrapper', { innerHTML: newImagesContent })

            .add([
                gsap.from(".LawPanel .content", { duration: 4, opacity: 0, y: 400, ease: "power1.out" }),
                gsap.to('.LawPanel .content', { duration: 4, opacity: 1, y: 0, ease: 'power1.out' }),
                gsap.from('.LawPanel .images_wrapper', { duration: 4, y: 400, opacity: 0, ease: 'power1.out' }),
                gsap.to('.LawPanel .images_wrapper', { duration: 4, y: 0, opacity: 1, ease: 'power1.out' }),

        ])

    }
});
});




  

document.addEventListener("DOMContentLoaded", function() {
  const scrollLine = document.getElementById("scroll-line");
  const content = document.querySelector(".page-id-14");
  const allForLawSection = document.querySelector(".AllForLaw");

  const observer = new IntersectionObserver(entries => {
    const isVisible = entries[0].isIntersecting;

    if (isVisible) {
      // Dodaj klasę "active" gdy sekcja .AllForLaw jest widoczna
      scrollLine.classList.add("active");
    } else {
      // Usuń klasę "active" gdy sekcja .AllForLaw nie jest widoczna
      scrollLine.classList.remove("active");
    }
  });

  observer.observe(allForLawSection);

  window.addEventListener("scroll", function() {
    const scrollPercentage = (window.scrollY / (content.offsetHeight - window.innerHeight)) * 100;

    // Ustaw widoczność paska przewijania
    scrollLine.style.top = `${scrollPercentage}%`;
  });
});
